/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 22nd 2022, 9:28:50 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { NestedOne2ManyInlineListEditor, ConcreteNestedOne2ManyInlineListEditorProps } from "ui-widgets/forms";
import { ICondition, isValueBasedCondition, FormConfiguration, FormField } from "lib/schemas";
import { getNewConditionDefault } from "lib/factories";
import { FormPicker, FieldPicker } from "form-builder/components";
import { ValueSelector } from "ui-widgets";
import { ConditionOperator } from "./ConditionOperator";

export const ConditionsNestedOne2ManyPicker = <PrimaryObject,>(
  props: ConcreteNestedOne2ManyInlineListEditorProps<PrimaryObject, ICondition>
) => {
  const [conditionForm, setConditionForm] = React.useState<FormConfiguration>();
  const [selectedField, setSelectedField] = React.useState<FormField>();

  return (
    <NestedOne2ManyInlineListEditor<PrimaryObject, ICondition>
      itemIdProperty={null}
      getNewItemDefaultValues={getNewConditionDefault}
      headerCells={{
        condition_field: <>Condition Field</>,
        condition_operator: <>Condition Operator</>,
        condition_value: <>Condition Value</>,
      }}
      bodyCells={{
        condition_field: (condition, handleChangeCondition) => (
          <>
            <FormPicker
              handleChooseForm={(form) => setConditionForm(form)}
              formId={conditionForm?.id}
              label="Choose Form"
            />
            <FieldPicker
              handleChooseField={(field) => {
                handleChangeCondition({ ...condition, condition_field: field?.artifact_guid });
                setSelectedField(field);
              }}
              onLoadIntial={setSelectedField}
              fieldIdentifier={condition.condition_field}
              label="Choose Field"
              formId={conditionForm?.id}
              apiQueryParams={{ include_choices: true }}
            />
          </>
        ),
        condition_operator: (condition, handleChangeCondition) => (
          <ConditionOperator
            condition_operator={condition.condition_operator}
            onChangeConditionOperator={(condition_operator) =>
              handleChangeCondition({
                ...condition,
                condition_operator,
              })
            }
          />
        ),
        condition_value: (condition, handleChangeCondition) => (
          <>
            {isValueBasedCondition(condition.condition_operator) ? (
              <ValueSelector
                label="Condition Value"
                chosenValue={condition.condition_value}
                onChangeValue={(condition_value) => handleChangeCondition({ ...condition, condition_value })}
                choices={selectedField?.resolved_choices}
              />
            ) : null}
          </>
        ),
      }}
      schema_field_key={props.schema_field_key}
      helperText="Configure conditions based on field input from forms within this service."
      label={props.label ?? "Conditions"}
    />
  );
};
